import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';

import type { StatisticsFilter } from '../../../common/types/statistics/statistics';

type Props = {
  statisticFilter: StatisticsFilter;
};

function GovStatisticHeader({ statisticFilter }: Props) {
  const year = statisticFilter.year;

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography
            fontSize='0.9rem'
            fontWeight='bold'
            mt={0.75}
            borderTop='2px solid black'
            borderBottom='3px solid black'
          >
            Förderung von Interventionsstellen in Bayern - Anonymisierte Statistik
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Typography fontSize='0.75rem' align='right' color='#FF0000' mr={0.25}>
            Aktualisierte Version Jan 2023/Koordinierungsstelle
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            Statistische Angaben
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ borderBottomWidth: 2, borderColor: '#000000' }} />
      <Grid container>
        <Grid item xs={12}>
          <Typography fontSize='0.75rem' align='right'>
            <b>Hinweis:</b> wenn nicht Kalenderjahr, bitte genauen Zeitraum angeben.
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ borderBottomWidth: 2, borderColor: '#000000' }} />
      <Grid container>
        <Grid item xs={7}>
          <Typography
            fontSize='0.75rem'
            fontWeight='bold'
            pl={0.5}
            borderRight='2px solid black'
            borderLeft='2px solid black'
            borderBottom='2px solid black'
          >
            für das Jahr/für den Zeitraum:
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem' align='right'>
            {year}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default GovStatisticHeader;
